<div class="flex flex-col gap-2 p-4 items-center" [hsLayer]="'one'">
  <kfm-signature-field
    class="border h-fit w-fit"
    [lineWidth]="lineWidth"
    [strokeStyle]="strokeStyle"
    [lineCap]="lineCap"
    [width]="width"
    [height]="height"
    [imgDataUrl]="imgDataUrl"
    #signatureField
  ></kfm-signature-field>

  <div class="flex flex-row w-full justify-end gap-2 p-2">
    <button
      hsButton
      hsButtonSize="sm"
      hsButtonVariant="outlined"
      (click)="dialogRef.close()"
    >
      Abbrechen
    </button>
    <button
      hsButton
      hsButtonSize="sm"
      hsButtonVariant="filled"
      (click)="dialogRef.close(signatureField.signatureDataUrl)"
    >
      Übernehmen
    </button>
  </div>
</div>
